export default __webpack_public_path__ + "static/media/disciplines_pink.f20f3750.svg";